
import * as React from "react";
import * as d3 from "d3";

interface IDonutChartProps {
    data?: number;
    containerClassName?: string;
    trailColor?: string;
    completeColor?: string;
}

export const ProgressBar: React.FC<IDonutChartProps> = props => {
    React.useEffect(() => {
        renderDonutChart();
    }, [])

    const renderDonutChart = () => {
        const { data, containerClassName, trailColor, completeColor } = props;
        let svg = d3.select(`.${containerClassName}`)
            .attr('height', 40)

        let segmentWidth = "100%";

        svg.append('rect')
            .attr('class', 'bg-rect')
            .attr('rx', 5)
            .attr('ry', 5)
            .attr('fill', trailColor)
            .attr('height', 7)
            .attr('width', segmentWidth)
            .attr('x', 0);

        let progress = svg.append('rect')
            .attr('class', 'progress-rect')
            .attr('fill', completeColor)
            .attr('height', 7)
            .attr('width', 0)
            .attr('rx', 5)
            .attr('ry', 5)
            .attr('x', 0);

        progress.transition()
            .duration(2000)
            .attr('width', `${data}%`)
    };

    return (
        <div>
            <svg className={props.containerClassName}></svg>
        </div>
    )
}